import styled from 'astroturf/react';

const Title = styled('div')`
  width: 437px;
  height: 44px;
  font-size: var(--ph-heading-one);
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--black);
  margin: 0 0 40px 0;
`;

const Left = styled('div')`
  padding: 25px;
  margin-right: 50px;
  background-color: var(--white);
  border-right: 1px solid rgba(var(--black), 0.1);
  height: 100%;
`;

const Wrapper = styled('div')`
  position: relative;
  overflow-x: hidden;
`;

const ExternalCAPUsersWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
`;

const Table = styled('table')`
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--white);
  width: 100%;
  font-size: var(--ph-text-sm);
  box-shadow: var(--ph-box-shadow-sm);
  border-collapse: collapse;
  margin-bottom: 40px;

  thead {
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-gray-100);
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: var(--white);
    padding: 0 10px;
  }

  td {
    border: 0;
    padding: 5px 10px;
  }
`;

export default {
  ExternalCAPUsersWrapper,
  Left,
  Table,
  Title,
  Wrapper,
};
